// extracted by mini-css-extract-plugin
module.exports = {"fullForm":"FullForm-module__fullForm___2XqLf","disabledForm":"FullForm-module__disabledForm___2ufB4"};